import styled from '@emotion/styled';

export const ModalFooterWrapper = styled.div`
  width: 100%;
`;

export const ModalHeaderWrapper = styled.div`
  width: 100%;
`;

export const ModalTitleWrapper = styled.div`
  width: 100%;
`;
